import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import getAccount from "Redux/Actions/GetAccountAction";

import * as ROUTES from "Constants/Routes";
import AppConstants from "Constants/AppConstants";
import STRINGS from "Constants/Strings";
import MODALMESSAGES from "Constants/Messages";

import PopupModal from "Components/Common/PopupModal/PopupModal";
import { S_APPLICANT_ID, HTTP_STATUS } from "Communication/Constants";

import { callCreateInverite } from "Components/Inverite/Actions/InveriteAction";
import { getProductFromVault } from "Components/MarketPlace/Action/MarketPlaceAction";
import BusinessKyc from "./BusinessKyc";
import {
  storeFilterBankingType,
  updateProductToVault,
} from "../MarketPlace/Action/MarketPlaceAction";
import withBusinessHOC from "../../Hoc/BusinessHOC";
import InveriteAccountList from "../Inverite/InveriteAccountList";
import Inverite from "../Inverite/Inverite";
import {
  doAddressKey,
  doCreateApplication,
  doGetAddress,
} from "../AboutYou/Actions/AboutYouActions";
import { searchMember } from "../../Redux/Actions/ApplicantAction";
import { getApplicant } from "../../Redux/Actions/ApplicationAction";
import updateApplicantData from "../../Redux/Actions/UpdateApplicantAction";
import { S_PERSONAL } from "../../Communication/Constants";

class BusinessKycContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      choice: "",
      showModal: false,
      iframeModal: false,
      showRequired: false,
      requiredList: null,
      iframeUrl: "",
      modalType: "",
      modal: {
        title: "",
        description: "",
        description2: null,
      },
      showVaultLimitError: false,
      showNonMember: false,
    };
  }

  componentDidMount() {
    const {
      doGetProductFromVault,
      products,
      personalData,
      doGetApplicant,
    } = this.props;

    if (products.length <= 0) {
      doGetProductFromVault((response) => {
        if (
          !response ||
          response.data?.length <= 0 ||
          sessionStorage.getItem(S_APPLICANT_ID)
        ) {
          const { history } = this.props;
          history.push(ROUTES.VAULT_DASHBOARD);
        }
      });
    }

    if (!personalData.id) {
      const personalId = sessionStorage.getItem(S_PERSONAL);
      if (personalId) {
        doGetApplicant({ id: personalId, isPersonalData: true });
      }
    }
  }

  showModal = () => {
    this.setState({
      showModal: true,
      modalType: AppConstants.MODALTYPE.INFORMATION,
      modal: {
        title: MODALMESSAGES.EXISTINGMEMBER.SUCCESS_TITLE,
        description: MODALMESSAGES.EXISTINGMEMBER.SUCCESS_MSG,
      },
    });
  };

  handleContinue = (data) => {
    const { continuehandler, doUpdateApplicant, doGetApplicant } = this.props;

    const personalId = sessionStorage.getItem(S_PERSONAL);

    doUpdateApplicant(data, personalId, (res) => {
      console.log(res);
      if (res.status === HTTP_STATUS.OK) {
        doGetApplicant({ id: personalId, isPersonalData: true });
        continuehandler(null, AppConstants.APPLICATIONSTEP.BUSINESS_KYC);
      }
    });
  };

  toggleModal = () => {
    this.setState({
      showModal: false,
      iframeModal: false,
      showRequired: false,
    });
  };

  render() {
    const {
      showModal,
      modalType,
      modal,
      iframeModal,
      iframeUrl,
      choice,
      showRequired,
      requiredList,
      showNonMember,
    } = this.state;
    const {
      productList,
      products,
      getActiveProduct,
      vaultProductList,
      finInfo,
      doAddressKey,
      doGetAddress,
      doSearchMember,
      getDataFromServer,
      personalData,
    } = this.props;

    const activeProduct = getActiveProduct(products);

    return (
      <>
        <BusinessKyc
          getActiveProduct={getActiveProduct}
          productList={productList}
          vaultProductList={vaultProductList}
          handleContinue={this.handleContinue}
          activeProduct={activeProduct}
          finInfo={finInfo}
          doAddressKey={doAddressKey}
          doGetAddress={doGetAddress}
          doSearchMember={doSearchMember}
          getDataFromServer={getDataFromServer}
          applicantData={personalData}
        />
      </>
    );
  }
}

BusinessKycContainer.propTypes = {
  history: PropTypes.oneOfType([PropTypes.object]),
  doGetAcoountDetails: PropTypes.func.isRequired,
  doCreateInverite: PropTypes.func.isRequired,
  doGetProductFromVault: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(PropTypes.object),
  inSessionJointApplicant: PropTypes.object,
  continuehandler: PropTypes.func.isRequired,
};

BusinessKycContainer.defaultProps = {
  history: null,
  products: [],
  inSessionJointApplicant: null,
  finInfo: {},
};

const mapStateToProps = (state) => ({
  MemberExists: state.MemberExistsReducer,
  products: state.VaultReducer.vaultProductList,
  inSessionJointApplicant: state.JoinApplicantReducer.inSessionJointApplicant,
  productList: state.MarketplaceReducer.productList,
  vaultProductList: state.VaultReducer.vaultProductList,
  loanProducts: state.LoanDetailsReducer.loanProducts,
  finInfo: state.MarketplaceReducer.finInfo,
  bankingType: state.MarketplaceReducer.bankingType,
  personalData: state.ApplicationReducer.personalData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    doGetAcoountDetails: (callback) => dispatch(getAccount(callback)),
    doCreateInverite: (callback) => dispatch(callCreateInverite(callback)),
    doGetProductFromVault: (callback) =>
      dispatch(getProductFromVault(callback)),
    doUpdateProductToVault: (vaultProductList, callback) =>
      dispatch(updateProductToVault(vaultProductList, callback)),
    doStoreFilterBankingType: (bankingType) =>
      dispatch(storeFilterBankingType(bankingType)),
    doAddressKey: (callback) => dispatch(doAddressKey(callback)),
    doGetAddress: (params, callback) =>
      dispatch(doGetAddress(params, callback)),
    doSearchMember: (params, callback) =>
      dispatch(searchMember(params, callback)),
    doGetApplicant: (payLoad, callback) =>
      dispatch(getApplicant(payLoad, callback)),
    doCreateNewApplicant: (request, callback) =>
      dispatch(doCreateApplication(request, callback)),
    doUpdateApplicant: (request, applicantId, callback) =>
      dispatch(updateApplicantData(request, applicantId, callback)),
  };
};

const BusinessExistWrapper = withBusinessHOC(BusinessKycContainer);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessExistWrapper);
